/** A header the user chose to turn into a new manual campaign custom column. */
export interface CustomColumnMapping {
  header: string
  name: string
}

/**
 * Collect custom-column mappings from the per-header custom names the user
 * entered in the Map step. Trims names, drops blank names, dedupes by header.
 */
export function collectCustomColumns(
  customNamesByHeader: Record<string, string>
): CustomColumnMapping[] {
  const out: CustomColumnMapping[] = []
  const seen = new Set<string>()
  for (const [header, rawName] of Object.entries(customNamesByHeader)) {
    const name = rawName.trim()
    if (!header || !name || seen.has(header)) continue
    seen.add(header)
    out.push({ header, name })
  }
  return out
}
